import React, { useEffect, useRef, useState } from "react";
import { useGlobalState } from "./GlobalStateProvider";
import { playSE } from "./SoundEffect";
import "./Nazo.css";
import { PostAchievement } from "./ModuleLinkFirebase";

export const PASS = "https://bad-assort.com/play/gothic-neue/pass.php";

export type JudgeRes = {
  "q"?: string,
  "judge": "ok" | "ng",
  "exemplar"?: string,
}

const NazoPhase: React.FC = () => {
  const { isBusy, setBusy, currentStep, setCurrentStep, ansArray, setAnsArray, logElements, setLogElements, hasKey } = useGlobalState();
  const [visibleNazoIndex, setVisibleNazoIndex] = useState<number>(0);
  const [yourAnsEffect, setYourAnsEffect] = useState<string>("");
  const [labelEffect, setLabelEffect] = useState<string>("");
  const yourAnsInputRef = useRef<HTMLInputElement | null>(null);
  const [p2Confirm, setP2Confirm] = useState<boolean>(false);
  const [isNameDenied, setNameDenied] = useState<boolean>(false);
  const [p4switch, setP4switch] = useState<boolean>(false);
  const turbulenceRef = useRef<SVGFETurbulenceElement>(null);
  const displacementRef = useRef<SVGFEDisplacementMapElement>(null);

  const sendAns = async () => {
    if (!yourAnsInputRef.current || !yourAnsInputRef.current.value) return;
    const currentPhase = Math.floor(currentStep / 10);
    if (ansArray[currentPhase][visibleNazoIndex]) return;
    setBusy(true);
    const res: JudgeRes = await judge();
    if (res.judge === "ok") {
      if (currentPhase === 6 && !hasKey) {
        setYourAnsEffect("youcant");
        setBusy(false);
        return;
      }
      setYourAnsEffect(currentPhase === 5 ? "flash-g" : "flash");
      playSE(currentPhase === 9 ? "se4" : "se1");
      let newArr = [...ansArray];
      const ex = yourAnsInputRef.current?.value ?? "回答済";
      newArr[currentPhase][visibleNazoIndex] = res.exemplar ?? ex;
      setAnsArray(newArr);
      setTimeout(() => {
        setYourAnsEffect("");
        if (currentPhase == 3 || currentPhase == 4 || currentPhase == 6) {
          setVisibleNazoIndex(0);
          let newArr = [...logElements];
          switch (currentStep) {
            case 36:
              newArr.push(`phase${currentStep}`);
              setLogElements(newArr);
              setCurrentStep(40);
              break;
            case 40:
              newArr.push("phase4");
              setLogElements(newArr);
              setCurrentStep(50);
              break;
            case 60:
              newArr.push(`phase6`);
              setLogElements(newArr);
              setCurrentStep((currentStep) => currentStep + 10);
              break;
            default:
              newArr.push(`phase${currentStep}`);
              setLogElements(newArr);
              setCurrentStep(currentStep + 1);
              break;
          }
          setBusy(false);
        } else {
          setVisibleNazoIndex(0);
          const count = ansArray[Math.floor(currentStep / 10)].flat().filter((ans) => ans !== null).length;
          if (count >= ansArray[Math.floor(currentStep / 10)].length) {
            setLabelEffect(currentPhase === 5 ? "flash-g" : "flash");
            setTimeout(() => {
              let newArr = [...logElements];
              switch (currentStep) {
                case 11:
                  newArr.push("phase1");
                  setLogElements(newArr);
                  setCurrentStep(20);
                  break;
                case 20:
                  setP2Confirm(true);
                  break;
                case 50:
                  newArr.push(`phase${Math.floor(currentStep / 10)}`);
                  setLogElements(newArr);
                  setCurrentStep((currentStep) => currentStep + 10);
                  break;
                case 90:
                  setCurrentStep(91);
                  break;
              }
            }, 1500);
          } else {
            setBusy(false);
          }
        }
      }, 2000);
      if (currentPhase === 9) {
        PostAchievement(res.exemplar ?? "");
      }
    } else {
      setYourAnsEffect("shake");
      playSE("se2");
      setTimeout(() => {
        setYourAnsEffect("");
        setBusy(false);
      }, 1000);
    }
  };

  const judge: () => Promise<JudgeRes> = async () => {
    const ur_ans = yourAnsInputRef.current?.value;
    if (ur_ans) {
      let dat = { "q": `ques${Math.floor(currentStep / 10)}${visibleNazoIndex}`, "a": ur_ans };
      let response = await fetch(PASS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dat)
      });
      let res = await response.json();
      return res;
    }
    return { "judge": "ng" };
  };

  const evac = () => {
    if (!yourAnsInputRef.current || !yourAnsInputRef.current.value) return;
    setBusy(true);
    const currentPhase = Math.floor(currentStep / 10);
    if (yourAnsInputRef.current.value === ansArray[currentPhase][visibleNazoIndex]) {
      setYourAnsEffect("flash");
      setTimeout(() => {
        setYourAnsEffect("");
        setCurrentStep(80);
        setBusy(false);
        PostAchievement(atob('YW1uZXNpYQ=='));
      }, 2000);
    } else {
      setYourAnsEffect("shake");
      setTimeout(() => {
        setYourAnsEffect("");
        setBusy(false);
      }, 1000);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (currentStep == 71) {
        evac();
      } else {
        sendAns();
      }
    }
  };

  const back = () => {
    setVisibleNazoIndex(0);
  };

  const splittedAns = (id: number) => {
    const splitted = ansArray[2][id]?.split("");
    if (splitted)
      return <>
        {splitted.map((char, index) => (
          <span
            key={index}
            style={{
              display: "block",
              transform: `translateY(${(index - splitted.length / 2 + 0.5) * 2}em)`,
              animation: `0.5s split-char 2s forwards`
            }}
          >
            {char}
          </span>
        ))}
      </>
    return <></>;
  };

  const animateGlitch = () => {
    let animationFrameId: number;
    let startAnimate = new Date().getTime();

    const animate = () => {
      let newTime = new Date().getTime();
      const delta = newTime - startAnimate;
      if (turbulenceRef.current) {
        const freqX = 0;
        const freqY = Math.cos(delta / 67) + Math.cos(delta / 247) - 0.5;
        turbulenceRef.current.setAttribute('baseFrequency', `${freqX} ${freqY}`);
        if (displacementRef.current) {
          displacementRef.current.setAttribute('in', freqY > 0 ? 'rgb-layers' : 'SourceGraphic');
        }
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationFrameId);
  };

  const clearPhase2 = () => {
    setLabelEffect("flash");
    playSE("se4");
    setTimeout(() => {
      let newArr = [...logElements];
      newArr.push("phase2");
      setLogElements(newArr);
      setCurrentStep(31);
      setLabelEffect("");
    }, 1500);
  }

  useEffect(() => {
    setBusy(false);
    setVisibleNazoIndex(() => {
      switch (currentStep) {
        case 31:
        case 32:
        case 33:
        case 34:
        case 35:
        case 36:
          return (currentStep % 10);
        default:
          return 0;
      }
    });
  }, []);

  useEffect(() => {
    if (visibleNazoIndex == 0) return;
    const prevAns = ansArray[Math.floor(currentStep / 10)][visibleNazoIndex] ?? "";
    if (yourAnsInputRef.current) {
      yourAnsInputRef.current.value = prevAns;
      yourAnsInputRef.current.disabled = prevAns.length > 0;
    }
  }, [visibleNazoIndex]);

  const phase1 = <>
    <section id="nz-phase1" className="nazo-section">
      <div id="nz-1-wrapper">
        <label id="nz-1-1" className={`${ansArray[1][1] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(1)}>
          <p className="fc">i</p>
          <p className="ans">{ansArray[1][1] ?? ""}</p>
        </label>
        <label id="nz-1-2" className={`${ansArray[1][2] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(2)}>
          <p className="fc">layt</p>
          <p className="ans">{ansArray[1][2] ?? ""}</p>
        </label>
        <label id="nz-1-3" className={`${ansArray[1][3] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(3)}>
          <p className="fc">sumany</p>
          <p className="ans">{ansArray[1][3] ?? ""}</p>
        </label>
        <label id="nz-1-4" className={`${ansArray[1][4] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(4)}>
          <p className="fc">maxyk</p>
          <p className="ans">{ansArray[1][4] ?? ""}</p>
        </label>
        <label id="nz-1-5" className={`${ansArray[1][5] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(5)}>
          <p className="fc">ton</p>
          <p className="ans">{ansArray[1][5] ?? ""}</p>
        </label>
        <label id="nz-1-6" className={`${ansArray[1][6] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(6)}>
          <p className="fc">neym</p>
          <p className="ans">{ansArray[1][6] ?? ""}</p>
        </label>
        <label id="nz-1-7" className={`${ansArray[1][7] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(7)}>
          <p className="fc">synayo</p>
          <p className="ans">{ansArray[1][7] ?? ""}</p>
        </label>
        <label id="nz-1-8" className={`${ansArray[1][8] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(8)}>
          <p className="fc">tuen</p>
          <p className="ans">{ansArray[1][8] ?? ""}</p>
        </label>
      </div>
      {visibleNazoIndex > 0 &&
        <div id="nz-1-modal" className="nz-modal">
          <img id="nz-1-img" src={`${process.env.PUBLIC_URL}/img/nazo1${visibleNazoIndex}.webp`}></img>
          <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
          <div>
            <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
            <div id="back-button" className="div-button" onClick={back}>戻る</div>
          </div>
        </div>
      }
    </section>
  </>;

  const phase2 = <>
    <section id="nz-phase2" className={`nazo-section${p2Confirm ? " confirm" : ""}`}>
      <div id="nz-2-wrapper">
        <p style={{ position: "absolute", top: "1em", fontSize: "1.5em" }}>Find your name.</p>
        <div id="nz-2-sq">
          <label id="nz-2-1" className={`${ansArray[2][1] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(1)}>
            <p className="no">1</p>
            <p className="ans">{splittedAns(1)}</p>
          </label>
          <label id="nz-2-2" className={`${ansArray[2][2] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(2)}>
            <p className="no">2</p>
            <p className="ans">{splittedAns(2)}</p>
          </label>
          <label id="nz-2-3" className={`${ansArray[2][3] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(3)}>
            <p className="no">3</p>
            <p className="ans">{splittedAns(3)}</p>
          </label>
          <label id="nz-2-4" className={`${ansArray[2][4] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(4)}>
            <p className="no">4</p>
            <p className="ans">{splittedAns(4)}</p>
          </label>
          <label id="nz-2-5" className={`${ansArray[2][5] ? "answered" : ""} ${labelEffect}`} onClick={() => !isBusy && setVisibleNazoIndex(5)}>
            <p className="no">5</p>
            <p className="ans">{splittedAns(5)}</p>
          </label>
        </div>
        <div id="phase2-confirm" className={p2Confirm ? "confirm" : ""}>
          <p>私の名前……これだっけ。</p>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="div-button" onClick={clearPhase2}>YES</div>
            <div className={`div-button${isNameDenied ? " denied" : ""}`} onClick={() => { setNameDenied(true); animateGlitch(); playSE("se3"); }}>NO</div>

            <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
              <filter id="displacementFilter">
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" result="g" />
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 1 0 0 0 0 0 1 0" result="b" />
                <feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                <feOffset dx="5" dy="1" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in="g" in2="" operator="lighter" />
                <feComposite in="b" in2="" operator="lighter" result="rgb-layers" />
                <feTurbulence ref={turbulenceRef} type="turbulence" baseFrequency="0 0" numOctaves="1" result="turb" />
                <feColorMatrix
                  in="turb"
                  type="matrix"
                  values="
            1 -1 0 0 0.5
            0 1 -1 0 0.5
            -1 0 1 0 0.5
            0 0 0 1 1"
                  result="centered"
                />
                <feDisplacementMap ref={displacementRef} in2="centered" in="SourceGraphic"
                  scale="20"
                  xChannelSelector="R"
                  yChannelSelector="G"
                />
              </filter>
            </svg>
          </div>
        </div>
      </div>
      {visibleNazoIndex > 0 &&
        <div id="nz-2-modal" className="nz-modal">
          <img id="nz-2-img" src={`${process.env.PUBLIC_URL}/img/nazo2${visibleNazoIndex}.webp`}></img>
          <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
          <div>
            <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
            <div id="back-button" className="div-button" onClick={back}>戻る</div>
          </div>
        </div>
      }
    </section>
  </>;

  const phase3 = <>
    <section id="nz-phase3" className="nazo-section">
      <div id="nz-3-modal" className="nz-modal">
        <img id="nz-3-img" src={`${process.env.PUBLIC_URL}/img/nazo3${visibleNazoIndex}.webp`}></img>
        <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
        <div>
          <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
        </div>
      </div>
    </section>
  </>;

  const phase4 = <>
    <section id="nz-phase4" className="nazo-section">
      <div id="nz-4-modal" className="nz-modal">
        <div style={{ display: "flex" }}>
          <img id="nz-4-img0" style={{ display: `${p4switch ? "none" : "block"}` }} src={`${process.env.PUBLIC_URL}/img/nazo40.webp`}></img>
          <img id="nz-4-img1" style={{ display: `${p4switch ? "block" : "none"}` }} src={`${process.env.PUBLIC_URL}/img/nazo41.webp`}></img>
        </div>
        <div className="div-button" onClick={() => { setP4switch(() => !p4switch) }}>
          {p4switch ? "2" : "1"}/2枚目を表示中
        </div>
        <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
        <div>
          <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
        </div>
      </div>
    </section>
  </>;

  const phase5 = <>
    <section id="nz-phase5" className="nazo-section">
      <div id="nz-5-wrapper">
        <img id="nz-5-paper1" src={`${process.env.PUBLIC_URL}/img/paper_51.webp`} onClick={() => !isBusy && setVisibleNazoIndex(1)}></img>
        <img id="nz-5-paper2" src={`${process.env.PUBLIC_URL}/img/paper_52.webp`} onClick={() => !isBusy && setVisibleNazoIndex(2)}></img>
        <img id="nz-5-paper3" src={`${process.env.PUBLIC_URL}/img/paper_53.webp`} onClick={() => !isBusy && setVisibleNazoIndex(3)}></img>
      </div>
      <p className={`sentence ${labelEffect}`}>
        <span>これは、</span>
        <span>{ansArray[5][1]}</span>
        <span>{ansArray[5][1] !== null && ansArray[5][2] !== null && "に"}</span>
        <span>{ansArray[5][2]}</span>
        <span>{ansArray[5][2] !== null && ansArray[5][3] !== null && "を"}</span>
        <span>{ansArray[5][3]}</span>
        <span>本。</span>
      </p>
      {visibleNazoIndex > 0 &&
        <div id="nz-5-modal" className="nz-modal">
          <img id="nz-5-img" src={`${process.env.PUBLIC_URL}/img/nazo5${visibleNazoIndex}.webp`}></img>
          <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
          <div>
            <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
            <div id="back-button" className="div-button" onClick={back}>戻る</div>
          </div>
        </div>
      }
    </section>
  </>;

  const phase6 = <>
    <section id="nz-phase6" className="nazo-section">
      <div id="nz-6-modal" className="nz-modal">
        <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy || !ansArray[6][1] || !ansArray[6][2] || !ansArray[6][3] ? true : false} autoComplete="off"></input>
        <div>
          <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
        </div>
      </div>
      <div id="find-key" className={yourAnsEffect} onClick={() => setYourAnsEffect("")}>
        <p>外せない。鍵がかかっている。</p>
      </div>
    </section>
  </>;

  const phase7 = <>
    <section id="nz-phase7" className="nazo-section">
      <div id="nz-7-modal" className="nz-modal">
        {currentStep > 70 && <p className="fc">i tnuy neym?</p>}
        <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy || currentStep == 70 ? true : false} autoComplete="off"></input>
        {currentStep > 70 &&
          <div id="judge-button" className="div-button" onClick={evac}>決定</div>
        }
      </div>
    </section>
  </>;

  const phase9 = <>
    <section id="nz-phase9" className="nazo-section">
      <div id="nz-9-modal" className="nz-modal">
        <p className="fc">kal i neym.</p>
        <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
        <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
      </div>
    </section>
  </>;

  switch (currentStep) {
    case 11:
      return phase1;
    case 20:
      return phase2;
    case 31:
    case 32:
    case 33:
    case 34:
    case 35:
    case 36:
      return phase3;
    case 40:
      return phase4;
    case 50:
      return phase5;
    case 60:
    case 61:
      return phase6;
    case 70:
    case 71:
      return phase7;
    case 90:
      return phase9;
    default:
      return phase1;
  }
}

export default NazoPhase;
